import johnLevis from "../../assets/images/trainers/trainer1.png";
import johnatanDoe from "../../assets/images/trainers/trainer2.png";
import anaJune from "../../assets/images/trainers/trainer3.png";

const trainerArray = [
  {
    image: johnLevis,
    name: "John Levis",
    specialization: "Yoga Trainer",
  },
  {
    image: johnatanDoe,
    name: "Johnatan Doe",
    specialization: "Fitness Instructor",
  },
  {
    image: anaJune,
    name: "Ana June",
    specialization: "Pilates Instructor",
  },
];

export default trainerArray;
